export default __webpack_public_path__ + "static/media/calendar.30241be6.svg";